import I18n from 'i18n-js';
import React from 'react';
import { IUserContext, withUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import SignupSigninModal from '@reverbdotcom/commons/src/components/signup_signin_modal';
import LocationUtil from '../shared/location_util';
import bind from '@reverbdotcom/commons/src/bind';
import { FOLLOW_PROMPT_PARAM } from '../shared/constants';
import heartEmptyIcon from '@reverbdotcom/cadence/icons/core/heart-empty.svg?component';
import { RCIcon } from '@reverbdotcom/cadence/components/RCIcon/RCIcon';
import classNames from 'classnames';

interface Props extends IUserContext {
  entityType: string;
  modalOpen: boolean;
  renderWithBanner: boolean;
}

interface State {
  modalOpen: boolean;
}

export class LoggedOutFavoriteButton extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: props.modalOpen,
    };
  }

  @bind
  handleClick(evt) {
    evt.preventDefault();

    this.setState({ modalOpen: true });
  }

  @bind
  handleModalClose() {
    this.setState({ modalOpen: false });
  }

  favoriteType() {
    return I18n.t(`discovery.favorites.favoriteButton.entityTypes.${this.props.entityType}`);
  }

  linkText() {
    return I18n.t('discovery.favorites.favoriteButton.addFavorite', { type: this.favoriteType() });
  }

  renderLoginModal() {
    const followPromptParams = { [FOLLOW_PROMPT_PARAM]: true };
    const redirectTo = LocationUtil.currentPageWithParams(followPromptParams);

    return (
      <SignupSigninModal
        onRequestClose={this.handleModalClose}
        active={this.state.modalOpen}
        message={I18n.t('discovery.searchSignup.fullLoginMessage')}
        redirectTo={redirectTo}
        trackSource="FavoriteButton"
      />
    );
  }

  buttonClass() {
    if (this.props.entityType === 'product') { return 'primary'; }
    if (this.props.renderWithBanner) { return 'primary'; }
    return 'link';
  }

  render() {
    if (!this.props.entityType) { return null; }
    const classes = classNames(
      'favorite-button__button',
      {
        'favorite-button__button-link': this.buttonClass() === 'link',
        'favorite-button__button-primary': this.buttonClass() === 'primary',
      },
    );
    return (
      <div className="favorite-button">
        <button
          type="button"
          className={classes}
          onClick={this.handleClick}
        >
          <RCIcon svgComponent={heartEmptyIcon} inline />
          {this.linkText()}
        </button>
        {this.renderLoginModal()}
      </div>
    );
  }
}

export default withUserContext(LoggedOutFavoriteButton);
